// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc, serverTimestamp } from "firebase/firestore";
import { getAuth, signInWithEmailAndPassword, signOut, onAuthStateChanged } from "firebase/auth";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDH73aPOMRyP6NVKSHIslsWHcToYGpJgaw",
  authDomain: "rwsite-7fc84.firebaseapp.com",
  projectId: "rwsite-7fc84",
  storageBucket: "rwsite-7fc84.firebasestorage.app",
  messagingSenderId: "139200038520",
  appId: "1:139200038520:web:142f78019634dc10a44f8d",
  measurementId: "G-F3LC6ZTM5Z"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { db, auth, storage };

// Helper function for safe document addition with error handling
export const addDocSafe = async (collectionName, data) => {
  try {
    const docRef = await addDoc(collection(db, collectionName), {
      ...data,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    });
    return { success: true, id: docRef.id };
  } catch (error) {
    console.error('Error adding document:', error);
    return { success: false, error: error.message };
  }
};

export const testFirestoreConnection = async () => {
  try {
    // Try a simple Firestore operation if needed
    return true;
  } catch (error) {
    return false;
  }
};

// Helper function for uploading images to Firebase Storage
export const uploadImage = async (file, path = 'article-images') => {
  try {
    const timestamp = Date.now();
    const fileName = `${timestamp}_${file.name}`;
    const storageRef = ref(storage, `${path}/${fileName}`);
    
    await uploadBytes(storageRef, file);
    const downloadURL = await getDownloadURL(storageRef);
    
    return { success: true, url: downloadURL };
  } catch (error) {
    console.error('Error uploading image:', error);
    return { success: false, error: error.message };
  }
};